module.exports = __webpack_public_path__ + "static/img/AirPods_Pro.82f8e8c8.jpg";